import React, { useState } from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { Box, Typography, CardMedia, Dialog } from "@mui/material";
import g1 from "../../assets/g1.jpeg";
import g2 from "../../assets/g2.jpeg";
import g3 from "../../assets/g3.jpg";
import g4 from "../../assets/g4.jpeg";
import g5 from "../../assets/g5.jpeg";
import g6 from "../../assets/g6.jpeg";
import g7 from "../../assets/g7.jpeg";
import achivement from "../../assets/achivement.jpeg";
import birthday from "../../assets/birthday.jpeg";
import g8 from "../../assets/g8.jpg";
import g9 from "../../assets/g9.jpg";
import g10 from "../../assets/g10.jpg";
import g11 from "../../assets/g11.jpg";

const images = [
  g1,
  g2,
  g3,
  g4,
  g5,
  g8,
  g6,
  g9,
  g10,
  g7,
  birthday,
  g11,
  achivement,
];

const WorkLifeGallery = ({ imageList = images }) => {
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleOpen = (image: any) => {
    setSelectedImage(image);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  return (
    <Box sx={{ padding: { xs: 0, sm: 3 } }}>
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{
          fontWeight: "bold",
          textTransform: "uppercase",
          background: "linear-gradient(180deg,rgb(32, 216, 124), #15741a)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        Our Gallery
      </Typography>

      {/* Responsive Masonry Layout */}
      <ResponsiveMasonry
        columnsCountBreakPoints={{ 350: 1, 768: 2, 1024: 3, 1400: 4 }}
      >
        <Masonry gutter="12px">
          {imageList.map((src, index) => (
            <CardMedia
              key={index}
              component="img"
              image={src.src}
              alt={`Gallery Image ${index + 1}`}
              onClick={() => handleOpen(src.src)}
              sx={{
                width: "100%",
                borderRadius: "5px",
                cursor: "pointer",
                boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                transition: "transform 0.3s ease-in-out",
                "&:hover": { transform: "scale(1.05)" },
              }}
            />
          ))}
        </Masonry>
      </ResponsiveMasonry>

      {/* Full-Screen Dialog */}
      <Dialog open={open} onClose={handleClose} maxWidth="md">
        {selectedImage && (
          <CardMedia
            component="img"
            image={selectedImage}
            alt="Selected Image"
            sx={{
              width: "100%",
              maxHeight: "90vh",
              objectFit: "contain",
            }}
          />
        )}
      </Dialog>
    </Box>
  );
};

export default WorkLifeGallery;
